import essApi from "../axios/essApi";

class SettingService {
  async getUsers() {
    return Promise.resolve(essApi.get(`users/userinfo-by-superiorId`));
  }

  async getUsersByProjectId(param) {
    return Promise.resolve(essApi.post(`users/userinfo-by-projectId`, param));
  }


  async getActivity() {
    return Promise.resolve(essApi.get(`activity`));
  }

  async getFilteredActivities(param) {
    return Promise.resolve(essApi.post(`filtered-activities`, param));
  }

  async getActivityById(id) {
    return Promise.resolve(essApi.get(`activityByProject/${id}`));
  }
  async getCategories() {
    return Promise.resolve(essApi.get(`categories`));
  }

  async getCategoriesByProjectId(id) {
    return Promise.resolve(essApi.get(`categories/${id}`));
  }

  async getFilteredCategories(param) {
    return Promise.resolve(essApi.post(`filtered-categories`, param));
  }
  async addProjectCategory(param) {
    return Promise.resolve(essApi.post(`categories`, param));
  }
  async addProjectActivity(param) {
    return Promise.resolve(essApi.post(`activity`, param));
  }
  async addActivityInBulk(param) {
    return Promise.resolve(essApi.post(`create-activity-bulk`, param));
  }
  async addCategoryInBulk(param) {
    return Promise.resolve(essApi.post(`create-categories-bulk`, param));
  }
  async deleteActivityById(id) {
    return Promise.resolve(essApi.delete(`activity/${id}`));
  }
  async bulkDeleteActivityById(body) {
    return Promise.resolve(essApi.post(`delete-activity-bulk`, body));
  }

  async deleteCategoryById(id) {
    return Promise.resolve(essApi.delete(`categories/${id}`));
  }
  async bulkDeleteCategoryById(ids) {
    return Promise.resolve(essApi.post(`buldDeleteCategories`, ids));
  }
  async deleteActivityByProjectId(id) {
    return Promise.resolve(essApi.delete(`delete-activity-by-projectId/${id}`));
  }
  async deleteCategoryByProjectId(id) {
    return Promise.resolve(
      essApi.delete(`delete-categories-by-projectId/${id}`)
    );
  }

  async getProjectsByUser() {
    return Promise.resolve(essApi.get(`projects-by-user?myProject=true`));
  }

  /*legal entity api*/
  async getLegalEntity() {
    return Promise.resolve(essApi.get(`legal-entity`));
  }
  async addLegalEntity(param) {
    return Promise.resolve(essApi.post(`legal-entity`, param));
  }
  async updateLegalEntity(param) {
    return Promise.resolve(essApi.put(`legal-entity/${param.id}`, param));
  }
  async deleteLegalEntityById(id) {
    return Promise.resolve(essApi.delete(`legal-entity/${id}`));
  }

  /*Customer api*/
  async getCustomers() {
    return Promise.resolve(essApi.get(`customers`));
  }
  async addCustomer(param) {
    return Promise.resolve(essApi.post(`customers`, param));
  }
  async updateCustomer(param) {
    return Promise.resolve(essApi.put(`customers/${param.id}`, param));
  }
  async deleteCustomerById(id) {
    return Promise.resolve(essApi.delete(`customers/${id}`));
  }

  /*BusinessUnit  api*/
  async getBusinessUnit() {
    return Promise.resolve(essApi.get(`business-unit`));
  }
  async addBusinessUnit(param) {
    return Promise.resolve(essApi.post(`business-unit`, param));
  }
  async updateBusinessUnit(param) {
    return Promise.resolve(essApi.put(`business-unit/${param.id}`, param));
  }
  async deleteBusinessUnitById(id) {
    return Promise.resolve(essApi.delete(`business-unit/${id}`));
  }
  async deleteAllBusinessUnit(param) {
    return Promise.resolve(essApi.post(`business-unit-delete`, param));
  }

  /*Project Type api*/
  async getProjectTypes() {
    return Promise.resolve(essApi.get(`project-type`));
  }

  /*project api*/
  async getProjects() {
    return Promise.resolve(essApi.get(`projects`));
  }
  async getActiveProjects() {
    return Promise.resolve(essApi.get(`active-projects`));
  }
  async addProject(param) {
    return Promise.resolve(essApi.post(`projects`, param));
  }
  async updateProject(param) {
    return Promise.resolve(essApi.put(`projects/${param.id}`, param));
  }
  async deleteProjectById(id) {
    return Promise.resolve(essApi.delete(`projects/${id}`));
  }

  /*Master-Activity api*/
  async getAllMasterActivity() {
    return Promise.resolve(essApi.get(`master-activity`));
  }
  async addMasterActivity(param) {
    return Promise.resolve(essApi.post(`master-activity`, param));
  }
  async updateMasterActivity(param) {
    return Promise.resolve(essApi.put(`master-activity/${param.id}`, param));
  }
  async deleteMasterActivityById(id) {
    return Promise.resolve(essApi.delete(`master-activity/${id}`));
  }

  /*Master category api*/
  async getAllMasterCategory() {
    return Promise.resolve(essApi.get(`master-categories`));
  }
  async addMasterCategory(param) {
    return Promise.resolve(essApi.post(`master-categories`, param));
  }
  async updateMasterCategory(param) {
    return Promise.resolve(essApi.put(`master-categories/${param.id}`, param));
  }
  async deleteMasterCategoryById(id) {
    return Promise.resolve(essApi.delete(`master-categories/${id}`));
  }

  /* Skills api*/
  async getSkills() {
    return Promise.resolve(essApi.get(`skills`));
  }
  async addSkills(param) {
    return Promise.resolve(essApi.post(`skills`, param));
  }
  async updateSkills(param) {
    return Promise.resolve(essApi.put(`skills/${param.id}`, param));
  }
  async deleteSkillsById(id) {
    return Promise.resolve(essApi.delete(`skills/${id}`));
  }

  /*Designation api*/
  async getDesignations() {
    return Promise.resolve(essApi.get(`designation`));
  }
  async addDesignations(param) {
    return Promise.resolve(essApi.post(`designation`, param));
  }
  async updateDesignations(param) {
    return Promise.resolve(essApi.put(`designation/${param.id}`, param));
  }
  async deleteDesignationsById(id) {
    return Promise.resolve(essApi.delete(`designation/${id}`));
  }

  /*Leave Absence Codes api*/
  //get all leave absence codes for admin
  async getAllAbsenceCodesForAdmin() {
    return Promise.resolve(essApi.get(`getAllAbsenceCodes`))
  }
  async addLeaveAbsenceCode(payload) {
    return Promise.resolve(essApi.post(`leaveAbsenceCode`, payload));
  }
  async updateLeaveAbsenceCode(param) {
    return Promise.resolve(essApi.put(`leaveAbsenceCode`, param));
  }
  async deleteAbsenceCodeById(id) {
    return Promise.resolve(essApi.delete(`leaveAbsenceCode/${id}`));
  }
  async deleteMultipleAbsenceCodes(param) {
    return Promise.resolve(essApi.post(`deleteAll-leaveAbsenceCode`, param));
  }

  /*Leave type api*/
  async getLeaveTypes() {
    return Promise.resolve(essApi.get(`leaveType`));
  }
  async addLeaveType(param) {
    return Promise.resolve(essApi.post(`leaveType`, param));
  }
  async updateLeaveType(param) {
    return Promise.resolve(essApi.put(`leaveType`, param));
  }
  async deleteLeaveTypeById(id) {
    return Promise.resolve(essApi.delete(`leaveType/${id}`));
  }
  async deleteAllLeaveType(param) {
    return Promise.resolve(essApi.post(`leaveType-delete`, param));
  }

  /*Project mapping type api*/
  async getAllProjectType() {
    return Promise.resolve(essApi.get(`projects`));
  }
  async updateProjectManager(param) {
    return Promise.resolve(essApi.put(`projects/${param.id}`, param));
  }

  async deleteAllLegalEntity(param) {
    return Promise.resolve(essApi.post(`legal-entity-multiple`, param));
  }
  async deleteAllDesignation(param) {
    return Promise.resolve(essApi.post(`designation-All-delete`, param));
  }
  async deleteAllActivity(param) {
    return Promise.resolve(essApi.post(`master-activity-delete-bulk`, param));
  }
  async deleteAllSkill(param) {
    return Promise.resolve(essApi.post(`skills-delete-multiple`, param));
  }
  async deleteAllProject(param) {
    return Promise.resolve(essApi.post(`projects-delete-multiple`, param));
  }
  async deleteAllCategory(param) {
    return Promise.resolve(essApi.post(`master-categories-bulk-delete`, param));
  }
  async deleteAllCustomer(param) {
    return Promise.resolve(essApi.post(`delete-multiple-customer`, param));
  }
  //filter project 
  async getProjectReport(param) {
    return Promise.resolve(essApi.post(`project-by-filter`, param));
  }

  /*department api*/
  async getDepartment() {
    return Promise.resolve(essApi.get(`department`));
  }
  async addDepartment(param) {
    return Promise.resolve(essApi.post(`department`, param));
  }
  async updateDepartment(param) {
    return Promise.resolve(essApi.put(`department/${param.id}`, param));
  }
  async deleteDepartmentById(id) {
    return Promise.resolve(essApi.delete(`department/${id}`));
  }
  async deletemultipaledepartment(param) {
    return Promise.resolve(essApi.post(`delete-multiple_department`, param));
  }

  async updateCategoryRate(param) {
    return Promise.resolve(essApi.put(`categories/${param.id}`, param));
  }
}

export default SettingService;